/* import __COLOCATED_TEMPLATE__ from './composer.hbs.js'; */
var _class, _descriptor, _dec, _class2, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Composer from '@intercom/composer-ember/lib/composer';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { ref } from 'ember-ref-bucket';
export let ComposerPublicAPI = (_class = class ComposerPublicAPI {
  constructor(e) {
    _initializerDefineProperty(this, "composer", _descriptor, this);
    this.composer = e;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "composer", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let ComposerComponent = (_dec = ref('composerElement'), _class2 = class ComposerComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "composerElement", _descriptor2, this);
    _initializerDefineProperty(this, "composer", _descriptor3, this);
    _initializerDefineProperty(this, "publicAPI", _descriptor4, this);
    _initializerDefineProperty(this, "isDragging", _descriptor5, this);
    _defineProperty(this, "editorContainer", void 0);
  }
  initComposer(element) {
    return new Composer(this.args.blocksDoc, this.args.config, this.args.onChange, element, this.args.onFocus, this.args.onBlur, this.args.previousDocument);
  }
  drop(e) {
    if (!e.dataTransfer || !this.composer?.state || !this.composer?.config.upload) {
      return;
    }
    let files = e.dataTransfer.files;
    let allowedImageFileTypes = this.composer.config.upload.allowedImageFileTypes;
    let allowedAttachmentTypes = this.composer.config.upload.allowedAttachmentTypes;
    if (files) {
      let hoverInfo = this.composer.hoverInfo(e);
      if (!hoverInfo) {
        return;
      }
      let pos = hoverInfo.nearestInsertionPoint?.pos || this.composer.state.prosemirrorState.doc.nodeSize - 2;
      for (let i = 0; i < files.length; i++) {
        if (allowedImageFileTypes.includes('*') || allowedImageFileTypes.includes(files[i].type)) {
          this.composer.commands.insertImageFileAtRange({
            from: pos,
            to: pos
          }, files[i]);
        } else if (allowedAttachmentTypes?.includes('*') || allowedAttachmentTypes?.includes(files[i].type)) {
          this.composer.commands.addAttachment(files[i]);
        }
      }
    }
    this.isDragging = false;
    return true;
  }
  resize() {
    if (this.composer) {
      this.composer.scrollOrResizeHandler();
    }
  }
  loadNewBlocks() {
    if (this.composer) {
      this.composer.loadNewBlocks(this.args.blocksDoc);
    } else {
      throw new Error('Tried to load blocks before the composer was ready');
    }
  }
  loadNewConfig() {
    if (this.composer) {
      this.composer.destroy();
      this.onEditorReady(this.editorContainer);
    } else {
      throw new Error('Tried to load a new config before the composer was ready');
    }
  }
  onEditorReady(element) {
    this.editorContainer = element;
    this.composer = this.initComposer(element);
    if (this.publicAPI) {
      this.publicAPI.composer = this.composer;
    } else {
      this.publicAPI = new ComposerPublicAPI(this.composer);
      if (this.args.onReady) {
        this.args.onReady(this.publicAPI);
      }
    }
  }
  willDestroy() {
    super.willDestroy();
    if (this.composer) {
      this.composer.destroy();
    }
  }
}, _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "composerElement", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "composer", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "publicAPI", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "isDragging", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "drop", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "drop"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "resize", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "resize"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "loadNewBlocks", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "loadNewBlocks"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "loadNewConfig", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "loadNewConfig"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onEditorReady", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onEditorReady"), _class2.prototype), _class2);
export { ComposerComponent as default };